import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCard,_vm._b({class:{ 'border-red': _vm.isError },attrs:{"outlined":"","flat":"","disabled":_vm.disabled}},'v-card',_vm.$attrs,false),[_c('div',{ref:"editor",style:({ height: _vm.height })})]),(_vm.isError)?_c('div',{staticClass:"errormessage pl-2"},[_c('span',{staticClass:"red--text"},[_vm._v(_vm._s(_vm.errorMessages[0]))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }